var avatarImage = 'fx_2d2fb1e5_cgja1i0';

export { avatarImage };
//# sourceMappingURL=image.vanilla.mjs.map
